import React, { useEffect, useState } from 'react';
import { useActiveTimer, useStopTimer } from '../../hooks/useTimeEntries';
import { formatTrackedDuration } from '../../lib/timeEntryLabel';
import { useAuthStore } from '../../store/auth';

const FloatingTimerRenderer = () => {
  const token = useAuthStore(state => state.token);
  const { data } = useActiveTimer(Boolean(token));
  const stopTimer = useStopTimer();
  const activeTimer = data?.active_timer;
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    localStorage.removeItem('activeFloatingTimer');
  }, []);

  useEffect(() => {
    if (!activeTimer?.started_at) {
      setElapsed(0);
      return undefined;
    }

    const tick = () => {
      const startedAt = new Date(activeTimer.started_at).getTime();
      const serverSeconds = Number(data?.current_seconds);
      const drifted = Number.isFinite(startedAt)
        ? Math.max(0, Math.floor((Date.now() - startedAt) / 1000))
        : 0;
      setElapsed(Number.isFinite(serverSeconds) ? Math.max(serverSeconds, drifted) : drifted);
    };

    tick();
    const intervalId = setInterval(tick, 1000);
    return () => clearInterval(intervalId);
  }, [activeTimer?.id, activeTimer?.started_at, data?.current_seconds]);

  if (!activeTimer) {
    return null;
  }

  return (
    <div
      className="fixed bottom-4 right-4 z-50 flex items-center gap-3 rounded-lg bg-gray-900 px-4 py-3 text-white shadow-lg"
      role="status"
      aria-live="polite"
    >
      <div>
        <p className="text-xs uppercase tracking-wide text-gray-300">Timer ativo</p>
        <p className="text-sm font-medium">{activeTimer.task?.title || 'Tarefa'}</p>
        <p className="font-mono text-lg">{formatTrackedDuration(elapsed)}</p>
      </div>
      <button
        type="button"
        className="rounded-md bg-red-600 px-3 py-2 text-sm font-medium hover:bg-red-500 disabled:opacity-60"
        onClick={() => stopTimer.mutate(activeTimer.id)}
        disabled={stopTimer.isPending}
      >
        Parar
      </button>
    </div>
  );
};

export default FloatingTimerRenderer;
